<template>
   <div id="container" style="    width: 100%;">

      <a-spin :spinning="reloading">
        
               <Font></Font>
       
         <div>
            <div style="display: flex;margin-bottom: 20px;"> <a-range-picker format="YYYY-MM-DD"
                  v-model:value="rangeTime" @change="changeTime" style="width: 500px;"     :disabled-date="disabledDate">


               </a-range-picker>
                          <search-type-component v-model:searchType="searchType" @changeSearchType="changeSearchType" />
            <div  style="position: relative;flex: 1;">
                  <a-input placeholder="搜索内容" ref="searchRef"  v-model:value="title" @blur="defaultKeywordShow=false"   @focus="defaultKeywordShow=true" allowClear @pressEnter="onSearch"></a-input>
                  <default-keyword-component :defaultKeywordShow="defaultKeywordShow" @clickKeyword="clickKeyword"></default-keyword-component>
            </div>
               <a-button type="primary" style="width: 100px; background: #00b2b9;
               border-color: #00b2b9;" @click="onSearch">
                  <template #icon>
                     <SearchOutlined  style="color:white"/>
                  </template>
               </a-button>

               <a-button v-if="exportVisible" type="primary" style="width: 100px;margin-left: 20px;" :class="{'exportButton':(articleCheckList.length > 0)}" @click="toBatch"
                  :disabled="!(articleCheckList.length > 0)">
                  导出
               </a-button>
               <div class="subscribeSet" @click="showModalKeywordVisible=true">订阅设置</div>
            </div>
            <div>

               <a-button  v-if="exportVisible" size="small" @click="checkAll">{{ checkAllValue == true ? '取消全选' : '全选'
                  }}</a-button>
            </div>
            <div v-if="articleTime !== ''"
               :class="fontSize == 2 ? 'title' : fontSize == 1 ? 'title titleSmall' : 'title titleBig'">
               {{
         articleTime }}</div>
         </div>
         <div  @scroll="handleScroll" class="scrollView" :style="scrollView">
            <div ref="stickyArticle" v-for="item, index in articleList" v-bind:key="item">

               <Article :checkButtonVisible="exportVisible" :article="item"
                  :updateTime="index > 0 ? articleList[index - 1].updateTime : ''" :zIndex="index + 10"
                  @returnChecked="returnChecked">
               </Article>


            </div>
            <div v-if="articleList.length == pagination.total">
               <Bottom></Bottom>
            </div>
         </div>
      </a-spin>
   </div>
   <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
      <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
   </a-modal>-->

   <a-modal centered v-model:visible="batchAgreeVisible" title="" :closable="false" :footer="null" width="50%">

      <div style="height: 500px;   overflow-y: auto">
         <div style="display: flex;align-items: center;">导出类型：<div style="display: flex;justify-content: center;">
        <a-checkbox-group  style="    display: flex
;" v-model:value="checkedTypeList" :options="articleTypeOptions" class='batchListAticleType'>

   </a-checkbox-group>
    </div></div>
         <div>是否导出已选文章（共{{ checkedList.length }}条）？</div>
         <div>以下文章分别是：</div>

         <div style="display: block;">
            <a-checkbox v-model:checked="modalCheckAll" :indeterminate="indeterminate" @change="onCheckAll">
               全选
            </a-checkbox>
         </div>
         <a-checkbox-group v-model:value="checkedList" :options="articleOptions" class='batchList'>

         </a-checkbox-group>


      </div>
      <div style="    display: flex;
    justify-content: flex-end;
    align-items: center;margin-top: 1rem;
">

         <a style="margin-right:20px" href="javascript:;" @click="batchAgreeVisible = false">取消</a>
         <a-button type="primary" @click="toBatchAgree()" :loading="confirmLoading">确定</a-button>
      </div>

   </a-modal>
   <!--订阅设置按钮-->
   <!-- <div class="subscribeSet" @click="showModalKeywordVisible=true">
            <div>
               <div>
             订阅
         </div>
         <div>
             设置
         </div>
            </div>
   </div> -->
   <KeywordComponent :showModalKeywordVisible="showModalKeywordVisible" @toShowKeyword="toShowKeyword"></KeywordComponent>
   <DownloadReport :downloadReport="downloadReport" @toSave="toSave" @toClose="toClose"></DownloadReport>
</template>
<script>
import { SearchOutlined } from '@ant-design/icons-vue';
import { reportArticleList } from '../homePageComponent/js/index'
import { mySubscribedArticleList, createArticleReport } from '../../views/js/index'
import DownloadReport from '../articleComponent/DownloadReport.vue';
import { reactive, watch, ref, onMounted, onActivated, computed, nextTick } from 'vue'
import store from '@/store'
import Article from '../articleComponent/Article'
import Font from '../articleComponent/Font'
import Bottom from '../articleComponent/Bottom'
import dayjs from 'dayjs'
import { useRouter } from 'vue-router';
import { Alert, message } from 'ant-design-vue/lib/components';
import router from '@/router';
import { debounce } from "lodash"
import KeywordComponent from './component/keywordComponent.vue';
import { createTitle } from '@/untils';
import SearchTypeComponent from '../homePageComponent/component/searchTypeComponent.vue'
import DefaultKeywordComponent from '../homePageComponent/component/defaultKeywordComponent.vue'
export default {
   components: { Article, SearchOutlined, Font, Bottom,DownloadReport,KeywordComponent,SearchTypeComponent,DefaultKeywordComponent },
   name: 'mySubcribeDetail',
   setup() {
      const $router = useRouter();
      const pagination = reactive({
         current: 1,
         size: 10,
         companyId: '',
         total: 0
      })
      const checkedList = ref([])
      const articleList = ref([])
      const articleTime = ref('')
      const downloadReport=ref(false)
      watch(() => store.getters.fontSize, (val) => {
         fontSize.value = store.getters.fontSize
      })
      watch(
         () => store.getters.reloadFlag,
         (val) => {
            if (val == true) {
               pagination.current = 1
               articleList.value = []
               //document.querySelector('.scrollView').scrollTop =  scrollY.value=0
            }
         })

      const storeCompany = computed(() => {
         if (store.getters.company)
            return store.getters.company
         else return {}
      })
      watch(
         () => storeCompany.value.companyId,
         (val, old) => {
            if (val) {
               articleList.value = []
               pagination.current = 1

               pagination.companyId = store.getters.company.companyId
               articleTime.value = ""
               checkedList.value = []
               articleCheckList.value = []
               checkAllValue.value = false


               title.value = ""
               rangeTime.value = (['', ''])
               if (old == null) {
                  reloadData('old')
               }


               toShowExport()
               toShowTable()
            }




         })
      onActivated(() => {
   
         if (storeCompany.value.companyId)
            reloadData()


      })
      const toShowExport = () => {
         if ((store.getters.company.companyType != 4 && store.getters.company.manager == 1) || (store.getters.company.companyType == 4 && (store.getters.company.vip == 2 || store.getters.company.vip == 4)))
            exportVisible.value = true
         else exportVisible.value = false
      }
      const reloadData = (val) => {


         if (store.getters.company.companyId) {
            if (val != 'old') {
               toShowExport()
               fontSize.value = store.getters.fontSize
               pagination.companyId = store.getters.company.companyId
            }
            if (val != 'old' && store.getters.reloadFlag == true) {
               articleList.value = []
               pagination.current = 1
               toShowTable()
               document.querySelector('.scrollView').scrollTop = scrollY.value = 0
               store.dispatch('reloadFlag', false)
            }
            else {

               if (articleList.value.length == 0) {
                  height.value = document.getElementById('container').offsetHeight

                  scrollView.value = { overflow: 'auto' }
                  if (val != 'old' && store.getters.company != null && store.getters.company.companyId != '') {
                     pagination.companyId = store.getters.company.companyId
                     toShowTable()
                  }
               }
               else {
                  document.querySelector('.scrollView').scrollTop = scrollY.value
               }
            }
         }


      }
      const toShowTable = () => {
  
         reloading.value = true
     
         var startTime = ''
         var endTime = ''

         if (rangeTime.value[0] != '') {
            startTime = dayjs(rangeTime.value[0]).format(dateFormat) + " 00:00:00"
            endTime = dayjs(rangeTime.value[1]).format(dateFormat) + " 23:59:59"

         }
         if (exportVisible.value == false) {
            scrollView.value = { height: (height.value - 100) + 'px', overflow: 'auto' }
         }
         else {
            scrollView.value = { height: (height.value - 150) + 'px', overflow: 'auto' }
         }
         var list = {queryType:searchType.value,  current: pagination.current, companyId: pagination.companyId, size: 10, title: title.value, startTime: startTime, endTime: endTime }
      
         mySubscribedArticleList(list).then((res) => {
            pagination.total = res.data.total
            for (var i in res.data.records) {
               res.data.records[i].checked = checkAllValue.value
            }
            articleList.value = createTitle(store.getters.company.companyId,pagination.current == 1 ? res.data.records : articleList.value.concat(res.data.records))
            reloading.value = false
            console.log(articleList.value,'articleList.value')
         })
      }


      const scrollView = ref('')
      const dateFormat = 'YYYY-MM-DD';
      const scrollTop = ref(0)
      const handleScroll = debounce((e) => {


         let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
         let windowHeitht = e.target.clientHeight; //能看到的页面的高度
         let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
         let total = scrollTop + windowHeitht
         if (scrollHeight - total < 20) {
            if (articleList.value.length != pagination.total) {
               if (reloading.value == false) {
                  pagination.current = pagination.current + 1
                  toShowTable()
               }
            }
         }
         const elements = stickyArticle.value
         var time = ''
         var flag = true



      }, 300)
      const reloading = ref(false)
      const visible = ref(true)
      const title = ref('')
      const rangeTime = ref(['', ''])
      const changeTime = () => {
         if (rangeTime.value == null) {
            rangeTime.value = ['', '']
         }
         onSearch()
      }
      const onSearch = () => {
         checkedList.value = []
         articleCheckList.value = []
         checkAllValue.value = false
         articleList.value = []
         pagination.current = 1
         articleTime.value = ""
         toShowTable()
      }
      const scrollY = ref(0)
      const stickyArticle = ref(null)

      const fontSize = ref(0)
      const articleCheckList = ref([])
      const checkAllValue = ref(false)
      const checkAll = () => {
         if (rangeTime.value[0] == '') {
            message.warning('请先选择起止日期，最多可以导出30天的文章！')
         }
         else {
            indeterminateCheckAll.value = !checkAllValue.value
            checkAllValue.value = !checkAllValue.value
            var list = []
            articleList.value.forEach(function (obj) {
               if (checkAllValue.value == true) {
                  list.push(obj.id)
               }
               obj.checked = checkAllValue.value

            });
            articleCheckList.value = list
         }
      }
      const returnChecked = (val) => {
         var result = articleCheckList.value.findIndex(item => item == val.value)
         articleList.value.find(item => item.id == val.value).checked = val.checked

         if (result == -1 && val.checked == true) {
            articleCheckList.value.push(val.value)
         }
         else if (val.checked == false && result > -1) {
            checkAllValue.value = false
            var arr = articleCheckList.value
            arr.splice(result, 1)
            articleCheckList.value = arr

         }




      }
      const checkButtonVisible = ref(false)
      const batchAgreeVisible = ref(false)
      const articleOptions = ref([])
      const toBatch = () => {
         modalCheckAll.value = true
         var list = []
         articleOptions.value = []
         if (checkAllValue.value == false) {
            checkedList.value = articleCheckList.value
            list = articleList.value.filter(item => checkedList.value.findIndex(i => i == Number(item.id)) > -1)
            articleOptions.value = list.map(function (item, index) { return { label: (index + 1) + "、" + item.title, value: item.id } })
            checkedTypeList.value=['标题','摘要','正文','附件']
            batchAgreeVisible.value = true
           
         }
         else {
            var startTime = ''
            var endTime = ''

            if (rangeTime.value[0] != '') {
               startTime = dayjs(rangeTime.value[0]).format(dateFormat) + " 00:00:00"
               endTime = dayjs(rangeTime.value[1]).format(dateFormat) + " 23:59:59"

            }

            reportArticleList({
               companyId: pagination.companyId, title: title.value, startTime: startTime, endTime: endTime
            }).then((res) => {
               if (res.data) {
                  var articleList = []

                  for (var i in res.data) {
                     articleList.push(res.data[i].id)
                     list.push({ label: (Number(i) + 1) + "、" + res.data[i].title, value: res.data[i].id })
                  }
                  checkedList.value = articleList
                  articleOptions.value = list

                  batchAgreeVisible.value = true
               }
               else {
                  message.warning(res.msg)
               }
            })
         }


         console.log(articleOptions, 'articleOptions', checkedList.value)

      }

      const modalCheckAll = ref(false)
      const indeterminate = ref(true)
      const onCheckAll = (e) => {

         checkedList.value = e.target.checked ? articleOptions.value.map(function (item) { return item.value }) : [],
            indeterminate.value = false

      };

      watch(
         () => checkedList.value,
         val => {
            indeterminate.value = !!val.length && val.length < articleOptions.value.length;
            modalCheckAll.value = val.length === articleOptions.value.length;

         },
      );
      const toBatchAgree = () => {
            var list =[]
         if (checkedTypeList.value && checkedTypeList.value.length > 0) {
         
            if(checkedTypeList.value&&checkedTypeList.value.length>0){
            for(var i in articleTypeOptions.value){
            if(checkedTypeList.value.indexOf(articleTypeOptions.value[i])>-1){
                list[i]=1
            }
            else{
                list[i]=0
            }
            }
       
            toSave(list)
        }
        else{
                message.warning('请选择任一个类型！')
        }
            }

            else {
               message.warning('请选择要导出的文章！')
            }
        




      }
      const indeterminateCheckAll = ref(false)
      const exportVisible = ref(false)
      const confirmLoading = ref(false)
      const height = ref(0)

      const toClose=()=>{
      
         downloadReport.value=false
      }
      const toSave=(value)=>{
         if(confirmLoading.value == false){
            confirmLoading.value = true
        
         
         var startTime = ""
               var endTime = ""

               if (rangeTime.value[0] != '') {
                  startTime = dayjs(rangeTime.value[0]).format(dateFormat) + " 00:00:00"
                  endTime = dayjs(rangeTime.value[1]).format(dateFormat) + " 23:59:59"

               }
         createArticleReport({ title: title.value, companyId: pagination.companyId, startTime: startTime, endTime: endTime, articleIds: checkedList.value,selection:value }).then(res => {

if (res.msg == '处理成功') {
   message.success('正在导出！')
   checkedList.value = []
   articleCheckList.value = []
   articleList.value.forEach((item) => {
      item.checked = false
   })
   batchAgreeVisible.value = checkAllValue.value=downloadReport.value= false
 
   store.dispatch("taskList", res.data)
   console.log(store.getters.taskList, ' store.getters.taskList')
}
else {
   message.warning('导出失败！')
}
confirmLoading.value = false
}).catch(() => {
confirmLoading.value=false
})
}
      }
      const checkedTypeList=ref(['标题','摘要','正文','附件'])
    const articleTypeOptions=ref(['标题','摘要','正文','附件'
        
    ])

      const showModalKeywordVisible=ref(false)
      const toShowKeyword=(flag)=>{
         if(flag==true)
      {
         onSearch()
         
      }         
showModalKeywordVisible.value=false
      }
      const disabledDate = (current) => {
         if (!current) return false; // 确保 current 存在
      const today = new Date();
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(today.getMonth() - 6); // 设置为6个月前
      return current < sixMonthsAgo || current > today; // 禁用今天之前的6个月外的日期

};

          const searchType = ref(0)
      const defaultKeywordShow =ref(false)
      const clickKeyword=(item)=>{
         title.value=item
         nextTick().then(()=>{
           searchRef.value.blur()
              onSearch()
         })
      }
       const changeSearchType=(val)=>{
         searchType.value=val
         if(title.value!='')
         onSearch()
      }
        const searchRef=ref(null)
      return {
         searchRef,
         changeSearchType,
         clickKeyword,
       
         defaultKeywordShow,
         searchType,
         disabledDate,
         toShowKeyword,
         showModalKeywordVisible,
         checkedTypeList,
         articleTypeOptions,
         downloadReport,
         toSave,
         toClose,
         confirmLoading,
         exportVisible,
         indeterminateCheckAll,
         toBatchAgree,
         height,
         checkedList,
         modalCheckAll,
         indeterminate,
         onCheckAll,
         toBatch,
         articleOptions,
         batchAgreeVisible,
         checkButtonVisible,
         returnChecked,
         checkAllValue,
         checkAll,
         articleCheckList,
         fontSize,
         articleTime,
         stickyArticle,
         scrollY,
         onSearch,
         changeTime,
         rangeTime,
         title,
         visible,
         reloading,
         scrollView,
         handleScroll,
         articleList,
         toShowTable,
         pagination,
      }
   },
   //记录离开时的位置
   beforeRouteLeave(to, from, next) {
      //保存滚动条元素div的scrollTop值
      this.scrollY = document.querySelector('.scrollView').scrollTop
      next();
   },
  
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../assets/style.scss';
.subscribeSet{
 
   letter-spacing: 1px;
      /* position: fixed; */
      right: 45px;
    border-radius: 5px;
    /* border: none; */
   //  box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, 0.5), 7px 7px 20px 0px rgba(0, 0, 0, 0.1), 4px 4px 5px 0px rgba(0, 0, 0, 0.1);
 
    /* padding: 5px 10px; */
    font-size: 14px;
    top: 11.8%;
    cursor: pointer;
    /* line-height: 28px; */
    padding: 5px 10px;
    line-height: normal;
    word-break: keep-all;
    margin-left: 20px;
    font-weight: 600;
    background: #fff;
  color: #00b2b9;
  border: 1px solid #00b2b9;
}
.subscribeSet:hover {
   background: #00b2b9;
   color: white;

}

.scrollView {
   margin: 10px 0px;
   overflow-x: hidden;
}
</style>
<style>
.batchList .ant-checkbox-group-item {
   display: block !important;
}

.batchList .ant-checkbox {
   display: inline-block !important;
}
</style>
<style  lang="scss">
.batchListAticleType{
   label{
      line-height: 20px;
   }
}
</style>
